import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { AdminContext } from 'contexts/AdminContext'

import { ListaPrecioSelect } from 'sharedComponents/select'

const ListaPrecioFormGroup = ({ fIsSubmitting, iError, iTouched, setFieldValue, flagEditar }) => {
  const __adminContext = React.useContext(AdminContext)

  const oneRowTrigger = React.useCallback(
    firstOption => {
      if (!flagEditar) {
        setFieldValue('_idListaPrecio', firstOption._id)
      }
    },
    [flagEditar, setFieldValue]
  )

  if (!!__adminContext.valoresConfiguracionSede._idListaPrecio) {
    return null
  }

  return (
    <Form.Group>
      <Form.Label text='LISTA' htmlFor='select-idListaPrecio' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idListaPrecio'>
          {({ field }) => (
            <ListaPrecioSelect
              {...field}
              id='select-idListaPrecio'
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              oneRowTrigger={oneRowTrigger}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(ListaPrecioFormGroup)
